module.exports = __webpack_public_path__ + "static/media/img-axum-screen@3x.458d8e39.png";